export default __webpack_public_path__ + "static/media/codesnippet8.1dfac40e.png";